import { FC } from "react";
import { useTranslation } from 'react-i18next';
import EditLevel from "../../../program/semester/modals/EditLevel";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  courseCodes: number[]|undefined;
  setCourseCodes: (courseCodes: number[]) => void;
}

const SelectLevelModal: FC<IProps> = ({
  visible,
  setVisible,
  courseCodes,
  setCourseCodes,
}) => {
  const { t } = useTranslation();
  return (
    <EditLevel
      visible={visible}
      onClose={() => {
        setCourseCodes([]);
        setVisible(false);
      }}
      onSubmit={() => setVisible(false)}
      values={courseCodes}
      setValues={setCourseCodes}
      closeButtonText={t('homepage.survey.button5')}
    />
  );
}

export default SelectLevelModal;
